export const ViewType = {
    MAIN: 'MAIN',
    COLLECTED: 'COLLECTED',
}